import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MIDNIGHT = () => {
  return (
    <CardSection id="MIDNIGHT" title="MIDNIGHT">
      <Paragraph>주어진 시간을 자정(00:00)으로 재설정합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MIDNIGHT(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 재설정하려는 시간입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>MIDNIGHT(`Date`)</Paragraph>
        <Img src="computeMidnight" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는
          날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>시간대에는 영향이 없습니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
